export default __webpack_public_path__ + "static/media/our-services-social-care-children-residential.ae3c6dd5.jpg";